module.exports = __webpack_public_path__ + "img/ico-reply-yes-historic.4361cd7f.svg";